import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { LayoutModule } from '../../../layouts/layout.module';
import { ExpenseService } from '../../../../_services';
import { CurrencyPipe } from '@angular/common'
import { ActionButtonModule } from '../../../../shared/action-button';
import { LiveSearchSelectModule } from '../../../../shared/live-search-select';
import { ExpenseRoutingModule } from './expenses-routing.module';
import { ExpenseListComponent } from './expense-list/expense-list.component';
import { ExpenseNewComponent } from './expense-new/expense-new.component';
import { DatePickerModule } from './../../../../shared/date-picker';
import { ContainerModule } from './../../../../shared/container';
import { ListContainerModule } from './../../../../shared/list-container';
import { MoneyModule } from '../common/money-module';
import { ExpenseProviders } from '../../../../_models';

import { TableModule } from '../../../../shared/table';
/*
import { ExpenseDetailComponent } from './expense-detail/expense-detail.component';
*/
import { ExpenseEditComponent } from './expense-edit/expense-edit.component';


@NgModule({
    imports: [
        CommonModule,
        LayoutModule,
        ExpenseRoutingModule,
        TableModule,
        FormsModule,
        ReactiveFormsModule,
        ActionButtonModule,
        LiveSearchSelectModule,
        DatePickerModule,
        ContainerModule,
        ListContainerModule,
        MoneyModule
    ],
    declarations: [
        ExpenseListComponent,
        ExpenseNewComponent,
        ExpenseEditComponent,
        /*
        ExpenseDetailComponent,
        */
    ],
    providers: [ExpenseProviders],
})
export class ExpensesModule { }



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/expenses/expenses.module.ts